import { render, staticRenderFns } from "./AddWorkspace.vue?vue&type=template&id=12775ffe&"
import script from "./AddWorkspace.vue?vue&type=script&lang=js&"
export * from "./AddWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports